import React from 'react';
import PropTypes from 'prop-types';
import styles from './EffortTypeCard.module.css';

export const EffortTypeCard = ({ 
  type, 
  level, 
  effort, 
  color,
  borderColor,
  isSelected, 
  onClick 
}) => {
  return (
    <button 
      className={`${styles.card} ${isSelected ? styles.selected : ''}`}
      style={{ borderColor: borderColor }}
      onClick={onClick}
      type="button"
    >
      <div className={styles.cardContent}>
        <div className={styles.titleSection}>
          <h3 className={styles.title}>{type} Effort</h3>
        </div>
        
        <div className={styles.effortSection}>
          <div 
            className={styles.effortValue}
            style={{ backgroundColor: borderColor }}
          >
            {effort}
          </div>        
        </div>
      </div>
    </button>
  );
};

EffortTypeCard.propTypes = {
  type: PropTypes.string.isRequired,
  level: PropTypes.string.isRequired, // High, Medium, Low
  effort: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
  borderColor: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func
};